import { FlexItem } from '@ms/yammer-web-core-ui/dist/components/Flex';
import React, { ReactNode, useCallback } from 'react';

import SuiteHeader from '../../SuiteHeader';

const headerHeight = 48;

type UseHeaderCallback = () => () => ReactNode;
export const useHeaderCallback: UseHeaderCallback = () =>
  useCallback(
    () => (
      <FlexItem grow={1} height={headerHeight}>
        <SuiteHeader />
      </FlexItem>
    ),
    []
  );
